const formatMasterObjects = data =>
  data.map(item => ({
    label: item.name,
    value: item.id || item.timeSeriesId
  }));

const addMasterObjectItem = (state, item) => {
  state.push(item);
  return state;
};

export const initialState = {
  masterObjectTypeLookupValues: {}
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_MASTER_OBJECT_TYPE_ID_LOOKUP_VALUES':
      return {
        masterObjectTypeLookupValues: {
          ...state.masterObjectTypeLookupValues,
          [action.payload.id]: formatMasterObjects(action.payload.data)
        }
      };

    case 'ADD_ADVANCED_VALUE':
      return {
        masterObjectTypeLookupValues: {
          ...state.masterObjectTypeLookupValues,
          [action.payload.id]: addMasterObjectItem(
            state.masterObjectTypeLookupValues[action.payload.id],
            action.payload.data
          )
        }
      };

    default:
      return state;
  }
};
